import { createSelector } from '@reduxjs/toolkit';
export const unread_news_selector = createSelector((state) => state.news.news_list, (state) => state.account.date_last_news_reading, (news_list, date_last_news_reading) => {
    return news_list == null
        ? 0
        : news_list.filter((news) => date_last_news_reading == null ||
            news.active_after >= date_last_news_reading).length;
});
